import React, { useEffect, useState, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Card, Table, Tag, Image, Modal, Upload } from "antd";
import { useReactToPrint } from "react-to-print";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import { useParams } from "react-router-dom";
import Notification from "../../services/Notification";
import { ComponentToPrint } from "./ComponentToPrint";
import { InvoiceToPrint } from "./InvoiceToPrint";
import CourierAddress from "./popup/addCourierAddress";
import generatePDF from "react-to-pdf";
import Notes from "./popup/addNotes";
import { socket } from "../../socket";

const OrderDetails = ({ id }) => {
  const [pageDetails, setPageDetails] = useState();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [selectImageOpen, setSelectImageOpen] = useState("");
  const [selectImage, setSelectImage] = useState(0);
  const [fileList, setFileList] = useState([]);
  const [disableBtn, setDisableBtn] = useState(false);
  const [disable, setDisable] = useState(false);
  const [open, setOpen] = useState(false);
  const [openNotes, setOpenNotes] = useState(false);
  const [data, setData] = useState([]);
  const [change, setChange] = useState();
  const params = useParams();
  const navigate = useNavigate();

  var originalText = Helper.UserRole();

  const componentRef = useRef();
  const invoiceRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const downloadInvoice = () => {
    generatePDF(invoiceRef, {
      filename: `Invoice_${pageDetails.gstOrderID || pageDetails?.orderId}.pdf`,
    });
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "Category",
      render: (Category, record) => {
        const productName = record?.BillingProductDetail?.BillingProduct?.name;
        const categoryName = Category?.name;

        if (categoryName && productName) {
          return `${categoryName} (${productName})`;
        }

        return categoryName || "-";
      },
    },
    {
      title: "Varient",
      dataIndex: "attributesDetails",
      render: (attributesDetails) =>
        attributesDetails &&
        attributesDetails.length > 0 &&
        attributesDetails.map((obj, i) => (
          <Tag color="#2db7f5" key={i}>
            {`${obj.Variant.name} : ${obj.name}`}
          </Tag>
        )),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Amount",
      dataIndex: "total",
      key: "total",
    },
  ];

  useEffect(() => {
    try {
      (async () => {
        const data = await axios
          .get("/order-info", {
            params: {
              id: params.id,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) {
          setPageDetails(data.data.data);
          setData([data.data.data]);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, [change]);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const imageUpload = async ({ file, onSuccess }) => {
    setDisableBtn(true);
    var formData = new FormData();
    formData.append("image", file);
    let data = await axios
      .post("image-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      setDisableBtn(false);
      onSuccess("ok");
    }
  };

  const handleCancel = () => setPreviewOpen(false);

  const handleClose = () => {
    setSelectImage(0);
    setSelectImageOpen(false);
  };

  const handleOk = () => {
    handlePrint();
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    );
  };

  const handleBeforeUpload = (file) => {
    const newName = generateFileName(file.name);
    const newFile = new File([file], newName, { type: file.type });
    return newFile;
  };

  const generateFileName = (originalName) => {
    const uuid = uuidv4();
    const extension = originalName.split(".").pop();
    return `${uuid}.${extension}`;
  };

  const saveImages = async () => {
    let fileName = _.map(fileList, "name");
    var now = new Date();
    var logfile_name = moment().format("DD-MM-YYYY");

    let data = await axios
      .post("/update-order-img", {
        ordersId: params.id,
        demoImages: fileName,
        demoImagesFolder: logfile_name,
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      Notification.success("Image added Successfully");
    }
  };

  const saveDesignImages = async () => {
    let fileName = _.map(fileList, "name");
    var now = new Date();
    var logfile_name = moment().format("DD-MM-YYYY");

    let data = await axios
      .post("/update-order-img", {
        ordersId: params.id,
        designImages: fileName,
        designImagesFolder: logfile_name,
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      Notification.success("Image added Successfully");
    }
  };

  const changeStatus = async () => {
    let data = await axios
      .post("/update-order-img", {
        ordersId: params.id,
        status: originalText == 2 ? "in-progress" : "shipped",
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      Notification.success("Status updated successfully");
      navigate("/");
    }
  };

  const handleUploadImages = ({ file, fileList }) => {
    if (file.status !== "uploading") {
      setFileList(fileList);
    }
  };

  const cancelOrder = async (id) => {
    let data = await axios
      .post("/calcel-order", {
        ordersId: id,
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      Notification.success("Status updated successfully");
      setDisable(false);
      navigate("/orders");
    }
  };

  function downloadImages() {
    // Create a folder (you may need server-side logic for this in a real-world scenario)
    const folderName = "downloaded_images";
    // You may need to handle folder creation on the server side

    // Start downloading images
    pageDetails?.images.forEach((imageUrl, index) => {
      setTimeout(function () {
        downloadImage(
          `https://thecharmingtreasure.in/orders/${pageDetails.imagesFolder}/${imageUrl}`,
          `${imageUrl}`,
        );
      }, index * 500);
    });
  }

  function downloadDesignImages() {
    // Create a folder (you may need server-side logic for this in a real-world scenario)
    const folderName = "downloaded_images";
    // You may need to handle folder creation on the server side

    // Start downloading images
    pageDetails?.designImages.forEach((imageUrl, index) => {
      setTimeout(function () {
        downloadImage(
          `https://thecharmingtreasure.in/orders/${pageDetails.designImagesFolder}/${imageUrl}`,
          `${imageUrl}`,
        );
      }, index * 500);
    });
  }

  function downloadImage(url, filename) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Error downloading image:", error));
  }

  const addAddress = () => {
    setOpen(true);
  };

  const closeModelPopup = () => {
    setOpen(false);
    setOpenNotes(false);
    setChange(Date.now());
  };

  const selectPhoto = () => {
    if (pageDetails.images.length > 0) {
      setSelectImageOpen(true);
    } else {
      handlePrint();
    }
  };

  function DescriptionComponent({ description }) {
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  }

  return (
    <Container fluid>
      <div className="order-details-pg">
        <Row>
          <Col md={12} className="order-details-pg-title">
            <div className="title-col">
              <div className="title-info">
                <span className="title">
                  Order ID : #{pageDetails?.orderId}
                </span>
                <span className="order-at">
                  Order Placed On :{" "}
                  {moment(pageDetails?.createdAt).format("L LTS")}
                </span>
                {pageDetails?.platform == "web" && (
                  <span className="order-at">
                    Payment ID : {pageDetails?.paymentId}
                  </span>
                )}
                {pageDetails?.trackingId && (
                  <span className="order-at">
                    Tracking ID : {pageDetails?.courierName} -{" "}
                    {pageDetails?.trackingId}
                  </span>
                )}
              </div>
              <div className="order-status">
                {pageDetails?.address?.name ? (
                  <Button
                    type="primary"
                    onClick={(e) => {
                      selectPhoto();
                    }}
                  >
                    Print
                  </Button>
                ) : (
                  ""
                )}
                {originalText == 2 || originalText == 4 ? (
                  <Button
                    type="primary"
                    className="ms-2"
                    onClick={(e) => {
                      changeStatus();
                    }}
                  >
                    Change Status
                  </Button>
                ) : (
                  ""
                )}
                {(pageDetails?.Shop?.shopNumber == 7 || originalText == 1) &&
                  pageDetails?.gstOrderID && (
                    <Button
                      type="primary"
                      className="ms-2"
                      onClick={() => {
                        downloadInvoice();
                      }}
                    >
                      Download Invoice
                    </Button>
                  )}
                {originalText == 1 && pageDetails?.status == "pending" ? (
                  <Button
                    danger
                    className="ms-2"
                    disabled={disable}
                    onClick={(e) => {
                      setDisable(true);
                      cancelOrder(pageDetails?.id);
                    }}
                  >
                    Cancel
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Col>
          <Col md={9}>
            <Card title="Items" bordered={false}>
              <Table columns={columns} dataSource={data} pagination={false} />
            </Card>
          </Col>
          <Col md={3}>
            <Card title="Order Summary" bordered={false}>
              <div className="order-summary">
                <div>
                  <p>SubTotal</p>
                  <p>Shipping</p>
                  <p style={{ color: "darkgreen" }}>Coupon </p>
                  <p className="total">Total</p>
                </div>
                <div>
                  <p>₹{pageDetails?.total}</p>
                  {pageDetails?.deliveryCharge ? (
                    <p>₹{pageDetails?.deliveryCharge}</p>
                  ) : (
                    <p>
                      <s>₹{pageDetails?.deliveryCharge}</s>
                    </p>
                  )}
                  <p style={{ color: "darkgreen" }}>
                    ₹{pageDetails?.totalDiscountAmount}
                  </p>
                  <p className="total">
                    ₹
                    {Number(pageDetails?.total) +
                      Number(
                        Number(pageDetails?.deliveryCharge) -
                          Number(pageDetails?.totalDiscountAmount),
                      )}
                  </p>
                </div>
              </div>
            </Card>
          </Col>
          <Col md={4}>
            <Card
              title="Customer Details"
              bordered={false}
              className="customer-details"
            >
              <label className="store-name">{pageDetails?.Shop?.name}</label>
              <p>
                <label>Shop No :</label> {pageDetails?.Shop?.shopNumber},
              </p>
              <p>
                <label>Phone Number:</label> +91 {pageDetails?.Shop?.phone}
              </p>
            </Card>
          </Col>
          <Col md={4}>
            <Card
              title="Notes"
              bordered={false}
              extra={
                <>
                  {(originalText == 1 || originalText == 2) && (
                    <Button
                      type="primary"
                      ghost
                      onClick={(e) => {
                        setOpenNotes(true);
                      }}
                    >
                      Add / Edit
                    </Button>
                  )}
                </>
              }
            >
              <DescriptionComponent description={pageDetails?.notes} />
            </Card>
          </Col>
          <Col md={4}>
            <Card
              title="Shipping Address"
              bordered={false}
              className="shipping-address"
              extra={
                <>
                  {(originalText == 1 || originalText == 2) && (
                    <Button
                      type="primary"
                      ghost
                      onClick={(e) => {
                        addAddress();
                      }}
                    >
                      Add / Edit
                    </Button>
                  )}
                </>
              }
            >
              {pageDetails?.address?.name && (
                <>
                  <p>{pageDetails.address.name}</p>
                  <p>{pageDetails.address.address},</p>
                  <p>
                    {pageDetails.address.states}, {pageDetails.address.city} -{" "}
                    {pageDetails.address.zip}
                  </p>
                  <p>Phone Number: +91 {pageDetails.address.phone}</p>
                  <p>WhatsApp Number: +91 {pageDetails?.address?.whatsApp}</p>
                </>
              )}
            </Card>
          </Col>
          <Col md={12}>
            <Card
              title="Images"
              bordered={false}
              className="shipping-address"
              extra={
                <Button
                  type="primary"
                  ghost
                  onClick={(e) => {
                    downloadImages();
                  }}
                >
                  Download
                </Button>
              }
            >
              {pageDetails?.images?.map((obj, i) => (
                <Image.PreviewGroup
                  preview={{
                    onChange: (current, prev) =>
                      console.log(
                        `current index: ${current}, prev index: ${prev}`,
                      ),
                  }}
                >
                  <Image
                    width={200}
                    src={`https://thecharmingtreasure.in/orders/${pageDetails.imagesFolder}/${obj}`}
                  />
                </Image.PreviewGroup>
              ))}
            </Card>
          </Col>
          {pageDetails?.platform == "web" && (
            <Col md={12}>
              <Card
                title="Product Images"
                bordered={false}
                className="shipping-address"
              >
                <div style={{ display: "inline-block", marginRight: "10px" }}>
                  <Image.PreviewGroup
                    preview={{
                      onChange: (current, prev) =>
                        console.log(
                          `current index: ${current}, prev index: ${prev}`,
                        ),
                    }}
                  >
                    <Image
                      width={200}
                      src={`https://thecharmingtreasure.in/uploads/${pageDetails?.BillingProductDetail?.BillingProduct?.images?.[0]}`}
                    />
                  </Image.PreviewGroup>
                </div>
              </Card>
            </Col>
          )}
          {originalText == 2 && (
            <Col md={12}>
              <div className="d-flex">
                <Upload
                  customRequest={imageUpload}
                  beforeUpload={handleBeforeUpload}
                  listType="picture"
                  multiple
                  defaultFileList={[]}
                  onPreview={handlePreview}
                  onChange={handleUploadImages}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
                <Button
                  type="primary"
                  className="ms-5"
                  disabled={disableBtn}
                  onClick={(e) => {
                    saveDesignImages();
                  }}
                >
                  Save
                </Button>
              </div>
            </Col>
          )}
          {originalText == 4 || originalText == 2 ? (
            <Col md={12}>
              <Card
                title="Design File"
                bordered={false}
                className="shipping-address"
                extra={
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      downloadDesignImages();
                    }}
                  >
                    Download
                  </Button>
                }
              >
                {pageDetails?.designImages?.map((obj, i) => (
                  <Image.PreviewGroup
                    preview={{
                      onChange: (current, prev) =>
                        console.log(
                          `current index: ${current}, prev index: ${prev}`,
                        ),
                    }}
                  >
                    <Image
                      width={200}
                      src={`https://thecharmingtreasure.in/orders/${pageDetails.designImagesFolder}/${obj}`}
                    />
                  </Image.PreviewGroup>
                ))}
              </Card>
            </Col>
          ) : (
            ""
          )}
          {originalText == 1 ||
            (originalText == 4 && (
              <Col md={12}>
                <div className="d-flex">
                  <Upload
                    customRequest={imageUpload}
                    beforeUpload={handleBeforeUpload}
                    listType="picture"
                    multiple
                    defaultFileList={[]}
                    onPreview={handlePreview}
                    onChange={handleUploadImages}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                  <Button
                    type="primary"
                    className="ms-5"
                    disabled={disableBtn}
                    onClick={(e) => {
                      saveImages();
                    }}
                  >
                    Save
                  </Button>
                </div>
              </Col>
            ))}
          <Col md={12}>
            <Card
              title="Product Final Images"
              bordered={false}
              className="shipping-address"
            >
              {pageDetails?.demoImages?.map((obj, i) => (
                <Image.PreviewGroup
                  preview={{
                    onChange: (current, prev) =>
                      console.log(
                        `current index: ${current}, prev index: ${prev}`,
                      ),
                  }}
                >
                  <Image
                    width={200}
                    src={`https://thecharmingtreasure.in/orders/${pageDetails.demoImagesFolder}/${obj}`}
                  />
                </Image.PreviewGroup>
              ))}
            </Card>
          </Col>
        </Row>
        <ComponentToPrint
          ref={componentRef}
          pageDetails={pageDetails}
          style={{ display: "none" }}
          image={selectImage}
        />
        <InvoiceToPrint ref={invoiceRef} pageDetails={pageDetails} />
        <Modal
          open={previewOpen}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewImage}
          />
        </Modal>
        <Modal
          open={selectImageOpen}
          title={"Please select the image"}
          onCancel={handleClose}
          onOk={handleOk}
        >
          <select
            id="selected-image"
            name="cars"
            className="select-print-image"
            value={selectImage}
            onChange={(e) => {
              setSelectImage(e.target.value);
            }}
          >
            {pageDetails?.images?.map((obj, i) => (
              <option value={i}>{i + 1}</option>
            ))}
          </select>
        </Modal>
        {open && pageDetails && (
          <CourierAddress
            show={open}
            close={closeModelPopup}
            details={pageDetails}
          />
        )}
        {openNotes && (
          <Notes
            show={openNotes}
            close={closeModelPopup}
            details={pageDetails}
          />
        )}
      </div>
    </Container>
  );
};

export default OrderDetails;
